import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Flex } from '@servicetitan/anvil2';
import { Table, TableColumn, useRowExpandColumn } from '@servicetitan/table';

import { OutboundMessagesStore } from '../stores/outbound-messages.store';
import { DebouncedSearch } from '../../components/debounced-search/debounced-search';
import { StatusFilter } from './status-filter';
import { TextCell } from './text-cell';
import { DateCell } from './date-cell';
import { StatusCell } from './status-cell';
import { DetailsRow } from './details-row';

import * as Styles from './outbound-messages.module.less';

export const OutboundMessages = provide({
    singletons: [OutboundMessagesStore],
})(
    observer(() => {
        const [store] = useDependencies(OutboundMessagesStore);
        const expandColumn = useRowExpandColumn();

        useEffect(() => {
            store.init();
        }, [store]);

        return (
            <div className={Styles.container}>
                <Flex direction="column" gap="2">
                    <div className={Styles.topPanel}>
                        <Flex direction="row" gap="2" alignItems="flex-end">
                            <DebouncedSearch
                                onChange={store.filterBySearchQuery}
                                externalValue={store.searchQuery}
                                placeholder="Search by Text, Recipient, Sender"
                            />
                            <StatusFilter />
                        </Flex>
                    </div>
                    <div className={Styles.tableContainer}>
                        <Table
                            tableState={store.tableState}
                            striped={false}
                            sortable
                            loading={store.isLoading}
                            detail={DetailsRow}
                        >
                            <TableColumn field="id" title="ID" editable={false} />
                            <TableColumn
                                field="recipientNumberE164"
                                title="Recipient"
                                editable={false}
                            />
                            <TableColumn
                                field="text"
                                title="Text"
                                cell={TextCell}
                                editable={false}
                            />
                            <TableColumn
                                field="dateCreated"
                                title="Date Created"
                                cell={DateCell}
                                editable={false}
                            />
                            <TableColumn field="messageType" title="Type" editable={false} />
                            <TableColumn
                                field="messageStatus"
                                title="Status"
                                cell={StatusCell}
                                editable={false}
                            />
                            {expandColumn}
                        </Table>
                    </div>
                </Flex>
            </div>
        );
    }),
);
